export default __webpack_public_path__ + "static/media/kitchen4-afterF-1920w.acad4a9e.avif";